export default {
  placeholder: 'Todos',
};
